/**
 * The household the user last had open, persisted in localStorage.
 *
 * Deliberately dependency-free and separate from household.service: the
 * store seeds itself from the pin on the very first render, and a store that
 * imports a service (which pulls in the supabase client) both inverts the
 * dependency direction and breaks in any test that mocks that service.
 *
 * The pin is a DISPLAY HINT, never authorisation. RLS decides what the user
 * can actually read, so a pin pointing at a household they no longer belong
 * to yields nothing rather than leaking rows.
 */
const ACTIVE_HOUSEHOLD_KEY = 'yaruta_active_household';

/** The pinned household, or null. Safe against disabled/full storage. */
export function getActiveHouseholdPin(): string | null {
  try {
    return localStorage.getItem(ACTIVE_HOUSEHOLD_KEY);
  } catch {
    return null;
  }
}

export function setActiveHouseholdPin(householdId: string): void {
  try {
    localStorage.setItem(ACTIVE_HOUSEHOLD_KEY, householdId);
  } catch {
    /* ignore — the pin is a convenience, resolution always has a fallback */
  }
}

/**
 * Drop a pin that no longer maps to a live membership (the user left or was
 * removed from that household, or it was deleted). Callers re-resolve after.
 */
export function clearStaleActiveHousehold(): void {
  try {
    localStorage.removeItem(ACTIVE_HOUSEHOLD_KEY);
  } catch {
    /* ignore */
  }
}
